module.exports = __webpack_public_path__ + "img/Mask-group1-1.68a120b1.png";